import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import * as S from "components/common/Input/style";
import Select from "react-select";
import { LabelsContext } from "helpers/contexts";
import MobileOptionList from "./MobileOptionList";
import ErrorMsg from "./ErrorMsg";
import { getDropdownIndicator } from "./HelperFunctions";

MobileSelectInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
  options: PropTypes.array.isRequired, //an array of object contains label and value for every option [{label: '', value: ''}]
  selectedValue: PropTypes.object,
  isSearchable: PropTypes.bool,
  iconInlineMargin: PropTypes.string,
  iconColor: PropTypes.string,
  iconSize: PropTypes.string,
  errorMsg: PropTypes.string,
  colorStyles: PropTypes.object,
  setFocused: PropTypes.func,
  value: PropTypes.object,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isInitiallyOpen: PropTypes.bool,
};

function MobileSelectInput(props) {
  const labels = useContext(LabelsContext);
  const iconName = props.disabled ? ICON_NAME.lock : ICON_NAME.default;
  const [isDrawerOpen, setIsDrawerOpen] = useState(props.isInitiallyOpen);

  function handleOnMenuOpen() {
    setIsDrawerOpen(true);
    props.onMenuOpen();
  }

  function handleIconClick() {
    setIsDrawerOpen(false);
    props.onMenuClose();
  }

  function handleOnClick(value) {
    setIsDrawerOpen(false);
    props.onChange(value);
    props.onMenuClose();
  }

  const DropdownIndicator = () => {
    return getDropdownIndicator(
      iconName,
      props.iconSize,
      props.iconColor,
      props.iconInlineMargin
    );
  };

  return (
    <>
      <S.SelectContainer>
        <Select
          onMenuOpen={handleOnMenuOpen}
          onChange={props.onChange}
          options={props.options}
          components={{ DropdownIndicator }}
          noOptionsMessage={() => labels.selectInput.notFound}
          styles={props.colorStyles}
          value={props.value}
          isDisabled={props.disabled}
          isClearable
          placeholder={props.placeholder}
          isSearchable={false}
          menuPortalTarget={document.body}
          menuIsOpen={false}
        />
        {props.errorMsg && <ErrorMsg errorMsg={props.errorMsg} />}
      </S.SelectContainer>
      <S.DrawerContainer
        isRtl={props.isRtl}
        open={isDrawerOpen}
        anchor="bottom"
      >
        <MobileOptionList
          iconClick={handleIconClick}
          isSearchable={props.isSearchable}
          options={props.options}
          onOptionClick={handleOnClick}
          selectedValue={props.value}
          listLabel={props.listLabel}
        />
      </S.DrawerContainer>
    </>
  );
}

const ICON_NAME = { default: "angle-down-small", lock: "lock-empty" };

export default MobileSelectInput;
